import {
  buildHtml,
  buildLink,
  KitchenSinkRoute,
  RouteSlotInput,
} from '@luks/ui';

import { cleanList } from '../../commons/cleanList';
import { buildDrupalImage } from '../Image';

export function mapTestimonialSlider(
  input: TestimonialSliderFragment,
): RouteSlotInput<typeof KitchenSinkRoute, 'body', 'SliderTestimonial'> {
  return {
    key: 'SliderTestimonial',
    input: {
      title: input.title,
      specialists:
        input.testimonial?.filter(cleanList).map((item) => ({
          testimonialDescription: item.author || '',
          testimonialDescriptionShort: item.author || '',
          Image: item.image
            ? buildDrupalImage(item.image, 'testimonial')
            : undefined,
          link:
            item.link?.url && item.link?.text
              ? {
                  Link: buildLink({ href: item.link.url }),
                  text: item.link.text,
                }
              : undefined,
          BlockquoteShort: buildHtml(
            item.textSummaryHtml
              .replace('<p>&nbsp;</p>', '')
              .replace(/<p>\s+<\/p>/g, ''),
          ),
          Blockquote: buildHtml(
            item.textFullHtml
              .replace('<p>&nbsp;</p>', '')
              .replace(/<p>\s+<\/p>/g, ''),
          ),
        })) || [],
    },
  };
}
